module.exports = __webpack_public_path__ + "img/logo-taipei-city@3x.451962ce.png";